import { Component, OnInit , ElementRef, Renderer2 , ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';
import { Location } from '@angular/common';
@Component({
  selector: 'echexpayment-permission',
  templateUrl: './permission-add.component.html',
  styleUrls: ['./permission.component.css']
})
export class PermissionAddComponent implements OnInit {
	
	permission: any = {};
	// permission: any = {role_id: '', permission_value: '', };
	createpermission: boolean = true;
	editpermission: boolean = false;
	public token: string;
	public planlist: string;
	public data;
	public filterQuery = "";
	public rowsOnPage = 1;
	public sortBy = "plan_name";
	public sortOrder = "asc";
	public roleList: {};
	busy:Subscription;
	NamecharacterLimitReached: { [key: string]: boolean } = {};
	public CheckOtp: boolean=false;
	

	public addChecks = false
	public addUsers = false;
	constructor(private router: Router,private location: Location, private renderer : Renderer2, private elementRef: ElementRef, private toastr: ToastrService, private userService: UserService, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService) { 
		this.router = router; 
		var currentUser = this.localStorageService.getData("currentUserToken");
		this.token =  currentUser.data.user_token;
	
	}

	ngOnInit() {
		this.getRoleList();
	}

	//Go back
	goBack() {
		this.location.back();
	}

	// get all roles in echexpayment
	getRoleList(){
		var data = {
			token:this.token,
		}
	  let responseData = <any>{};
	  this.busy = this.userService.getRoleLists(data).subscribe(
		 response => {
		 responseData = response;
			this.roleList  = responseData; 
		 },
		 error => {
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
		 }
		);
	}
	
	updateOtp(inputElement: HTMLInputElement) {
		const inputValue = inputElement.value.trim(); // Remove leading/trailing whitespace
		if (inputValue.length >= 1 && inputValue.length <= 5) {
		  this.CheckOtp = false;
		} else {
		  this.CheckOtp = true;
		}
	}

	// Create Permission
	Create_Permission(data) {
		this.focusFirstInvalidControlPlus();   //focus field
		if(data.valid){
			    let model: any = data.value;
				model.token = this.token
				let responseData = <any>{};
				this.busy = this.echexpaymentService.createPermission(model).subscribe(
					response => {
					responseData = response;
					this.toastr.success(responseData.message, 'Success!');
					this.router.navigate(['/permisions']);
					},
				error => {
					responseData = error;
					this.toastr.error(responseData.error.message, 'Failed!');
				
				}
				);
		}
	}

	  // Enter Key Focus Next Field
	  @ViewChild('submitButton') submitButton: ElementRef;
	  moveNext(nextInput: HTMLInputElement, checkbox: number) {
		if(checkbox === 2){
			if (this.submitButton && this.submitButton.nativeElement) {
				this.submitButton.nativeElement.focus();
				this.submitButton.nativeElement.click();
			}
		} else{
			nextInput && nextInput.focus();
		}
	}
	// Focus Error Field
	  focusFirstInvalidControlPlus(): void {
		  const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
		  if (firstElementWithErrors) {
			  firstElementWithErrors.focus();
		  }
	  }

	  	// characters Limit check
		  NameCharacterLimit(event: any, fieldName: string) {
			const maxTextLength = 25; // Maximum text length of 20 characters
			const inputChar = event.key;
			const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
			const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
		  
			if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
			  return;
			}
		  
			const inputValue = event.target.value;
		  
			if (inputValue.length >= maxTextLength) {
			  if (allowedKeys.indexOf(inputChar) === -1) {
				this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
				setTimeout(() => {
				  this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
				}, 3000);
				event.preventDefault(); // Prevent entering the exceeded character
			  }
			}
		}
		  
	  isNameLimitReached(fieldName: string): boolean {
		  return this.NamecharacterLimitReached[fieldName];
	  }


	  @ViewChild('Roll_Id') selectBox: ElementRef;
	  ngAfterViewInit(){
			// this.renderer.selectRootElement('#initialFocus').focus();
			if (this.selectBox && this.selectBox.nativeElement) {
				this.selectBox.nativeElement.focus();
			}
	  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/permission/permission-add.component.ts